import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Typography, Badge, Divider } from "@mui/material";
import MoodIcon from "@mui/icons-material/Mood";

const SentimentFilterMenu = ({ filters, setFilters, fetchData }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isActive = !!filters.sentiment;
  
  // Helper function to get sentiment name
  const getSentimentName = (sentiment) => {
    const sentimentMap = {
      "1": "Negative",
      "2": "Neutral",
      "3": "Positive"
    };
    return sentimentMap[sentiment] || sentiment;
  };

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSentimentSelect = (sentiment) => {
    // Apply the sentiment filter
    const newFilters = { ...filters, sentiment };
    
    setFilters(newFilters);
    fetchData(newFilters);
    handleMenuClose();
  };

  const clearSentimentFilter = () => {
    // Remove sentiment filter
    const { sentiment, ...remainingFilters } = filters;
    
    setFilters(remainingFilters);
    fetchData(remainingFilters);
    handleMenuClose();
  };

  return (
    <div>
      <Badge 
        color="primary" 
        variant="dot" 
        invisible={!isActive}
        overlap="circular"
      >
        <IconButton 
          onClick={handleMenuClick}
          color={isActive ? "primary" : "default"}
          title="Filter by sentiment"
        >
          <MoodIcon />
        </IconButton>
      </Badge>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            borderRadius: "8px",
            marginTop: "8px",
            width: "200px",
          },
        }}
      >
        <Typography variant="subtitle1" sx={{ px: 2, py: 1, fontWeight: 'bold' }}>
          Sentiment
        </Typography>
        {isActive && (
          <Typography variant="body2" sx={{ px: 2, pb: 1, fontSize: '0.8rem', color: 'primary.main' }}>
            Active: {getSentimentName(filters.sentiment)}
          </Typography>
        )}
        <MenuItem onClick={() => handleSentimentSelect("1")} selected={filters.sentiment === "1"}>
          Negative (1)
        </MenuItem>
        <MenuItem onClick={() => handleSentimentSelect("2")} selected={filters.sentiment === "2"}>
          Neutral (2)
        </MenuItem>
        <MenuItem onClick={() => handleSentimentSelect("3")} selected={filters.sentiment === "3"}>
          Positive (3)
        </MenuItem>
        
        <Divider sx={{ my: 1 }} />
        
        <MenuItem 
          onClick={clearSentimentFilter}
          disabled={!isActive}
        >
          <Typography color={isActive ? "error" : "text.disabled"}>
            {isActive ? "Clear Sentiment Filter" : "No Sentiment Filter Applied"}
          </Typography>
        </MenuItem>
      </Menu>
    </div>
  );
};

export default SentimentFilterMenu;
